import clsx from 'clsx'
import { Icon } from '@iconify/react'
import MyAvatar from 'src/components/MyAvatar'
import React, { useRef, useState, useEffect } from 'react'
import PopoverMenu from 'src/components/PopoverMenu'
import { makeStyles } from '@material-ui/core/styles'
import { Box } from '@material-ui/core'
import { MIconButton } from 'src/theme'
import { authenticationLogoutAction } from 'src/reducers/authentication/action'
import { meService } from 'src/api/authentication'
import { useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'
const useStyles = makeStyles(theme => ({
  btnAvatar: {
    padding: 0,
    width: 44,
    height: 44,
  },
  header: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
    margin: '0 0 4px',
    padding: 10,
    borderBottom: '1px solid #F1F3F5',
  },
  name: {
    fontSize: '14px',
    fontWeight: 600,
    color: '#002E47',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  email: {
    fontSize: '12px',
    color: '#637381',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    whiteSpace: 'nowrap',
  },
  item: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    width: '100%',
    height: 38,
    padding: '0 10px',
    border: 0,
    borderRadius: 8,
    background: 'transparent',
    cursor: 'pointer',
    fontFamily: 'inherit',
    fontSize: '13px',
    fontWeight: 500,
    textAlign: 'left',
    '&:hover': {
      background: '#F4F6F8',
    },
  },
  line: {
    height: 1,
    margin: '4px 6px',
    background: '#F1F3F5',
  },
  isSelected: {
    '&:before': {
      zIndex: 1,
      content: "''",
      width: '100%',
      height: '100%',
      borderRadius: '50%',
      position: 'absolute',
    },
  },
}))

// ----------------------------------------------------------------------

/**
 * Account menu. `renderTrigger` replaces the default avatar button; it gets
 * `{ ref, onClick, initials, isOpen }`.
 */
function Account({ popoverProps, renderTrigger }) {
  const dispatch = useDispatch()
  const classes = useStyles()
  const history = useHistory()
  const anchorRef = useRef(null)
  const [isOpen, setOpen] = useState(false)
  const handleOpen = () => {
    setOpen(true)
  }
  const handleClose = () => setOpen(false)

  const openAccount = () => {
    setOpen(false)
    history.push('/profile')
  }

  const handleLogout = () => {
    dispatch(authenticationLogoutAction())
  }

  const [user, setUser] = useState(window.CONSTANTS.NAME)
  const [surName, setSurName] = useState(window.CONSTANTS.SUR_NAME || '')
  const [email, setEmail] = useState(window.CONSTANTS.EMAIL || '')
  useEffect(() => {
    meService().then(res => {
      setUser(res.data.name)
      setSurName(res.data.surname || '')
      setEmail(res.data.email || '')
    })
  }, [])
  const firstCharsAtName = user?.charAt(0) + surName?.charAt(0)

  return (
    <>
      {renderTrigger ? (
        renderTrigger({
          ref: anchorRef,
          onClick: handleOpen,
          initials: firstCharsAtName,
          isOpen,
        })
      ) : (
        <MIconButton
          ref={anchorRef}
          onClick={handleOpen}
          className={clsx(classes.btnAvatar, { [classes.isSelected]: isOpen })}
        >
          <MyAvatar text={firstCharsAtName} />
        </MIconButton>
      )}

      {/* Who is signed in, then My account and Log out. Custom Domain and
          Automations live on the Workspace page, Help in the side nav. */}
      <PopoverMenu
        width={232}
        open={isOpen}
        onClose={handleClose}
        anchorEl={anchorRef.current}
        {...popoverProps}
      >
        <Box sx={{ p: 0.75 }}>
          <div className={classes.header}>
            <span className={classes.name}>
              {[user, surName].filter(Boolean).join(' ')}
            </span>
            {email && <span className={classes.email}>{email}</span>}
          </div>
          <button
            type="button"
            className={classes.item}
            style={{ color: '#002E47' }}
            onClick={openAccount}
          >
            <Icon icon="tabler:user" width={16} height={16} />
            Account
          </button>
          <div className={classes.line} />
          <button
            type="button"
            className={classes.item}
            style={{ color: '#C9383B' }}
            onClick={handleLogout}
          >
            <Icon icon="tabler:logout" width={16} height={16} />
            Log out
          </button>
        </Box>
      </PopoverMenu>
    </>
  )
}

export default Account
